import type { User } from '@/types';
import api from './api';

interface AuthResult {
  success: boolean;
  user?: User;
  error?: string;
}

interface LogoutAllResult {
  success: boolean;
  revokedSessions?: number;
}

interface SessionsResult {
  success: boolean;
  sessions: unknown[];
  count?: number;
}

const authServiceV2 = {
  async login(email: string, password: string): Promise<AuthResult> {
    try {
      const response = await api.post('/auth/v2/login', { email, password });
      return {
        success: true,
        user: response.data.user,
      };
    } catch (error: any) {
      console.error('Login error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || 'Erreur de connexion',
      };
    }
  },

  async getCurrentUser(): Promise<AuthResult> {
    try {
      const response = await api.get('/auth/v2/me');
      return {
        success: true,
        user: response.data,
      };
    } catch (error: any) {
      if (error.response?.status === 401) {
        return { success: false, error: 'Not authenticated' };
      }
      console.error('Get current user error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || 'Erreur',
      };
    }
  },

  async refresh(): Promise<boolean> {
    try {
      const response = await api.post('/auth/v2/refresh', {});
      return response.data.success === true;
    } catch (error) {
      console.error('Token refresh failed:', error);
      return false;
    }
  },

  async logout(): Promise<{ success: boolean }> {
    try {
      await api.post('/auth/v2/logout');
      return { success: true };
    } catch (error) {
      console.error('Logout error:', error);
      return { success: true };
    }
  },

  async logoutAll(): Promise<LogoutAllResult> {
    try {
      const response = await api.post('/auth/v2/logout-all');
      return {
        success: true,
        revokedSessions: response.data.revoked_sessions,
      };
    } catch (error) {
      console.error('Logout all error:', error);
      return { success: false };
    }
  },

  async getSessions(): Promise<SessionsResult> {
    try {
      const response = await api.get('/auth/v2/sessions');
      return {
        success: true,
        sessions: response.data.sessions,
        count: response.data.count,
      };
    } catch (error) {
      console.error('Get sessions error:', error);
      return { success: false, sessions: [] };
    }
  },
};

export default authServiceV2;
